import React from "react";
import { Link } from "react-router-dom";
import "ui/SideDrawer/SideDrawer.css";

const SideDrawer = (props) => {
  let drawerClasses = "side-drawer";
  if (props.show) {
    drawerClasses = "side-drawer open";
  }

  return (
    <nav className={drawerClasses} id="sidebar">
      <ul>
        <Link to="/"
          onClick = {() => {
            props.closeSideDrawer();
          }}
        >
          <li>Go to Topic list</li>
        </Link>
      </ul>
    </nav>
  );
};

export default SideDrawer;
